import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

interface withdraw {
    coinId: string,
    coinWallet: string,
    recipientwalletAddress: string,
    networkId: string,
    coinName: string,
    coinSymbol: string,
    coinOfNetworkId:string
}
const initialState: withdraw = {
    coinId: '',
    coinWallet: '',
    recipientwalletAddress: '',
    networkId: '',
    coinName: '',
    coinSymbol: '',
    coinOfNetworkId:''

};
export const withdraw = createSlice({
    name: "withdraw",
    initialState,
    reducers: {
        coinInfo: (state, action: PayloadAction<{
            coinName: string,
            coinId: string,
            coinSymbol: string
        }>) => {
            console.log('coin info inside store', action.payload)
            state.coinId = action.payload.coinId
            state.coinName = action.payload.coinName,
                state.coinSymbol = action.payload.coinSymbol
        },
     
        networkInfo: (state, action: PayloadAction<string>) => {
            // console.log('updateCoinWalletStatus', action.payload.status)

            state.networkId = action.payload
        },
        updateAddress: (state, action: PayloadAction<string>) => {
            state.recipientwalletAddress = action.payload
        },
        updateCoinOfNetwrokId:(state,action:PayloadAction<string>)=>{
            state.coinOfNetworkId=action.payload
        }
        // updateCoinWalletStatus: (state, action: PayloadAction<{
        //     status: string,
        //     walletAddress: string,
        //     networkId: string,
        // }>) => {
        //     // console.log('updateCoinWalletStatus', action.payload.status)
        //     state.coinWallet = action.payload.status
        //     state.walletAddress = action.payload.walletAddress
        //     state.networkId = action.payload.networkId
        // },

    },
});
export const { coinInfo, networkInfo, updateAddress ,updateCoinOfNetwrokId} = withdraw.actions;

export default withdraw.reducer;
